import { Component,  Input } from '@angular/core';
import { Performer } from 'globals/store/performers.data';
import { PersonCardComponent } from './person-card.component';

@Component({
    selector: 'performer-card',
    template: `
  <person-card [size]="size" [cardTitle]="performer.name || ''" [photoUrl]="performer.photoUrl" [bold]="bold" [disableSelect]="true"
    [subtitle]="onlyName ? '' : (performer.line1 || '') + (performer.line1 && performer.line2 ? ', ' : '') + (performer.line2 || '')" >
  </person-card>
`,
    standalone: true,
    imports: [PersonCardComponent],
})

export class PerformerCardComponent {
  @Input() performer: Performer
  @Input() hidePhoto = false
  @Input() size = 36
  @Input() bold = false
  @Input() onlyName = false

}
